var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isShowWrap,
      expression: "isShowWrap"
    }],
    staticClass: "wrap"
  }), _c("div", {
    staticClass: "search"
  }, [_c("van-search", {
    attrs: {
      readonly: "",
      placeholder: _vm.$t("Search"),
      shape: "round"
    },
    on: {
      click: _vm.toSearch
    },
    model: {
      value: _vm.searchTxt,
      callback: function callback($$v) {
        _vm.searchTxt = $$v;
      },
      expression: "searchTxt"
    }
  }), _c("div", {
    staticClass: "add-con"
  }, [_c("div", {
    staticClass: "add",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.toPost.apply(null, arguments);
      }
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/ic_feedback_add.png"),
      alt: ""
    }
  })])])], 1), _c("van-tabs", {
    ref: "tabs",
    attrs: {
      "title-active-color": "rgba(255,255,255)",
      "title-inactive-color": "rgba(255,255,255,0.60)",
      swipeable: "",
      ellipsis: false,
      "swipe-threshold": "4"
    },
    on: {
      change: _vm.tabChange
    },
    model: {
      value: _vm.activeName,
      callback: function callback($$v) {
        _vm.activeName = $$v;
      },
      expression: "activeName"
    }
  }, [_vm._l(_vm.themeArr, function (item) {
    return _c("van-tab", {
      key: item,
      attrs: {
        title: _vm.$t(item),
        name: item
      }
    });
  }), _c("transition", {
    attrs: {
      name: _vm.transitionName
    }
  }, [_vm.show ? _c("router-view", {
    staticClass: "Router"
  }) : _vm._e()], 1)], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };